// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"035f11c3","765":"8b80ae2a"}[chunkId] + ".chunk.js";
};